import qs from 'qs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { api } from '$app/api';

dayjs.extend(utc);

export function openFixterAccessLink(userId, bookingId) {
  return api.get(`case-managers/${userId}/bookings/${bookingId}/login`, {
    data: {},
  });
}

export function fetchCustomerServicePromo(customerId, customerFirstName) {
  return api.get(`campaigns/customer/${customerId}?customerName=${customerFirstName}`, {
    method: 'get',
  });
}

export function changeVrm(bookingId, vrm, segment) {
  return api.post(`bookings/${bookingId}/changeVrm`, { vrm, segment });
}

export function updateBookingTags(bookingId, tags) {
  return api.patch(`bookings/${bookingId}`, { tags });
}

export function updateCustomerDetails(customerId, patch) {
  return api.patch(`customers/${customerId}`, patch);
}

export function createCustomerNote(bookingUuid, note) {
  return api.post(`/bookings/${bookingUuid}/notes`, note);
}

export function sendCustomerConfirmationEmail({ bookingId, customerId, bookingUuid }) {
  return api.post(`customers/${customerId}/bookings/${bookingId}/customer-notification`, {
    eventType: 'BookingConfirmationRequest',
    body: {
      bookingId: bookingUuid,
    },
  });
}

export function generateCustomerInvoice(bookingId, author) {
  return api.post(`bookings/${bookingId}/generateCustomerInvoice`, { author });
}

export async function updateCustomerPaymentMethod({ bookingId, customerId, paymentMethodId, bookingUuid, segment, token }) {
  const { data } = await api.post(`customers/${customerId}/payment-methods`, {
    ownerId: bookingUuid,
    ownerType: 'booking',
    paymentMethodId,
    token,
    segment,
  });

  return api.put(`/bookings/${bookingId}/payment-method`, {
    paymentMethodId: data.paymentId,
  });
}

export async function saveCustomerPromo({ customer, customerServicePromo, patch, segment }) {
  const isPending = customerServicePromo.status === 'PENDING';
  const { campaignId } = customerServicePromo;

  const newCampaignData = {
    name: customerServicePromo.name,
    label: customerServicePromo.label,
    code: customerServicePromo.code,
    customerId: customer.id,
    discountAmountPence: patch.amount * 100,
    appliedToCheckout: patch.applyToCheckout,
    appliedToEWO: patch.applyToEWO,
    type: customerServicePromo.type,
    validFromDate: customerServicePromo.validFromDate,
    validUntilDate: customerServicePromo.validUntilDate,
    singleUse: customerServicePromo.singleUse,
    emailPromoCodeToCustomer: patch.emailPromoCodeToCustomer,
    customerEmail: customer.email,
    segment,
  };

  const editCampaignData = {
    discountAmountPence: patch.amount * 100,
  };

  const response = isPending
    ? await api.post(`campaigns/customer/${customer.id}`, newCampaignData)
    : await api.patch(`campaigns/customer/${customer.id}/${campaignId}`, editCampaignData);

  return { response, isPending };
}

export function deleteCustomerPromo(customerId, campaignId) {
  return api.patch(`campaigns/customer/${customerId}/${campaignId}`, {
    validUntilDate: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
  });
}

export function buildCreateBookingUrl(accessLink, username, utmMedium, utmSource, utmCampaign) {
  return `${accessLink}&${qs.stringify({
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_content: username,
  })}`;
}
